import rest from "@/rest-client";

export const accountNotification = {
  moduleName: "accountNotification",
  namespaced: true,

  state: () => ({
    pagination: undefined,
  }),
  getters: {
    pagination: (state) => state.pagination,
    unreads: (state) => state.pagination?.docs?.filter((n) => !n.readed),
  },
  mutations: {
    pagination(state, pagination) {
      state.pagination = pagination;
    },
    unshift(state, item) {
      if (state.pagination?.docs) {
        state.pagination.docs = [item, ...state.pagination.docs];
      }
    },

    markAsRead(state, item) {
      if (state.pagination?.docs) {
        state.pagination.docs = state.pagination.docs.map((n) => {
          if (n._id != item._id) {
            return n;
          }

          n.readed = true;
          return n;
        });
      }
    },

    remove(state, item) {
      state.pagination.docs = state.pagination.docs.filter((n) => n._id != item._id);
    },

    markAsReadAll(state) {
      if (state.pagination?.docs) {
        state.pagination.docs = state.pagination.docs.map((n) => {
          n.readed = true;
          return n;
        });
      }
    },
  },
  actions: {
    async paginate({ commit }, request) {
      try {
        const payload = { pagination: { ...request } };
        const response = await rest.post("/notification", payload);
        commit("pagination", response.data);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    unshift({ commit }, item) {
      commit("unshift", item);
    },

    async markAsRead({ commit }, item) {
      try {
        const response = await rest.get("/notification/mark-read/" + item._id);
        commit("markAsRead", item);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async remove({ commit, dispatch }, item) {
      try {
        const response = await rest.delete("/notification/" + item._id);
        commit("remove", item);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async markAsReadAll({ commit }) {
      try {
        const response = await rest.get("/notification/mark-read-all");
        commit("markAsReadAll");
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export const workspaceNotification = {
  moduleName: "workspaceNotification",
  namespaced: true,

  state: () => ({
    pagination: undefined,
  }),
  getters: {
    pagination: (state) => state.pagination,
    unreads: (state) => state.pagination.docs.filter((n) => !n.readed),
  },
  mutations: {
    pagination(state, pagination) {
      state.pagination = pagination;
    },
    unshift(state, item) {
      state.pagination.docs = [item, ...state.pagination.docs];
    },

    markAsRead(state, item) {
      state.pagination.docs = state.pagination.docs.map((n) => {
        if (n._id != item._id) {
          return n;
        }

        n.readed = true;
        return n;
      });
    },

    remove(state, item) {
      state.pagination.docs = state.pagination.docs.filter((n) => n._id != item._id);
    },

    markAsReadAll(state) {
      state.pagination.docs = state.pagination.docs.map((n) => {
        n.readed = true;
        return n;
      });
    },
  },
  actions: {
    async paginate({ commit }, request) {
      try {
        const payload = { pagination: { ...request } };
        const response = await rest.post("/notification/workspace", payload);
        commit("pagination", response.data);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    unshift({ commit }, item) {
      commit("unshift", item);
    },

    async markAsRead({ commit }, item) {
      try {
        const response = await rest.get("/notification/mark-read/" + item._id);
        commit("markAsRead", item);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async remove({ commit, dispatch }, item) {
      try {
        const response = await rest.delete("/notification/" + item._id);
        commit("remove", item);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async markAsReadAll({ commit }) {
      try {
        const response = await rest.get("/notification/mark-read-all/workspace");
        commit("markAsReadAll");
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
};

export const organizationNotification = {
  moduleName: "organizationNotification",
  namespaced: true,

  state: () => ({
    pagination: undefined,
  }),
  getters: {
    pagination: (state) => state.pagination,
    unreads: (state) => state.pagination.docs.filter((n) => !n.readed),
  },
  mutations: {
    pagination(state, pagination) {
      state.pagination = pagination;
    },
    unshift(state, item) {
      state.pagination.docs = [item, ...state.pagination.docs];
    },

    markAsRead(state, item) {
      state.pagination.docs = state.pagination.docs.map((n) => {
        if (n._id != item._id) {
          return n;
        }

        n.readed = true;
        return n;
      });
    },

    remove(state, item) {
      state.pagination.docs = state.pagination.docs.filter((n) => n._id != item._id);
    },

    markAsReadAll(state) {
      state.pagination.docs = state.pagination.docs.map((n) => {
        n.readed = true;
        return n;
      });
    },
  },
  actions: {
    async paginate({ commit }, request) {
      try {
        const payload = { pagination: { ...request } };
        const response = await rest.post("/notification/organization", payload);
        commit("pagination", response.data);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    unshift({ commit }, item) {
      commit("unshift", item);
    },

    async markAsRead({ commit }, item) {
      try {
        const response = await rest.get("/notification/mark-read/" + item._id);
        commit("markAsRead", item);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async remove({ commit, dispatch }, item) {
      try {
        const response = await rest.delete("/notification/" + item._id);
        commit("remove", item);
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },

    async markAsReadAll({ commit }) {
      try {
        const response = await rest.get("/notification/mark-read-all/organization");
        commit("markAsReadAll");
        return response.data;
      } catch (e) {
        console.error(e);
      }
    },
  },
};
